import { DAYS_OF_WEEK } from '@gozoki/api-types'
import { z } from 'zod'
import { STORE_DASHBOARD_DATE_PRESETS } from '~/components/routes/store-dashboard/filters/date-shortcuts'

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/)

const windowSearch = {
  storeId: z.number().int().positive().optional(),
  preset: z.enum(STORE_DASHBOARD_DATE_PRESETS).optional(),
  startDate: isoDate.optional(),
  endDate: isoDate.optional(),
  compStartDate: isoDate.optional(),
  compEndDate: isoDate.optional(),
  comparableMode: z.enum(['auto', 'custom']).optional().default('auto'),
}

export const storeDashboardSearchSchema = z.object(windowSearch)
export type StoreDashboardSearch = z.infer<typeof storeDashboardSearchSchema>

export const storeHoursSearchSchema = z.object({
  ...windowSearch,
  days: z
    .array(z.enum(DAYS_OF_WEEK))
    .min(1)
    .optional()
    .default([...DAYS_OF_WEEK]),
  plage: z.enum(['AM', 'PM', 'DAY']).optional().default('DAY'),
})
export type StoreHoursSearch = z.infer<typeof storeHoursSearchSchema>
